import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../_uLearn/layout/core";
import AppSettings from "./appSettings";

const profileBreadCrumbs: Array<PageLink> = [
  {
    title: "App Settings",
    path: "App Settings",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];
const index = () => (
  <Routes>
    <Route
      element={
        <>
          <Outlet />
        </>
      }
    >
      <Route path="*" element={<Navigate to="/error/404" />} />
      <Route
        // path=""
        index
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>App Settings</PageTitle>
            <AppSettings />
          </>
        }
      />
    </Route>
  </Routes>
);
export default index;
